import "../css/app.css";
import "./bootstrap";

import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

const appName = import.meta.env.VITE_APP_NAME || "Sav-Rx Passport";

createInertiaApp({
    title: (title) => `${appName} - ${title}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob("./Pages/**/*.tsx"),
        ),
    setup({ el, App, props }) {
        Sentry.init({
            dsn: import.meta.env.VITE_DSN,
            release: import.meta.env.VITE_SENTRY_RELEASE,

            integrations: [
                Sentry.feedbackIntegration({
                    isEmailRequired: true,
                    isNameRequired: true,
                    colorScheme: "system",
                    autoInject: false,
                }),
                Sentry.replayIntegration(),
            ],
            replaysSessionSampleRate:
                parseFloat(import.meta.env.VITE_REPLAY_SESSION_SAMPLE_RATE) ||
                0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate:
                parseFloat(import.meta.env.VITE_REPLAY_ON_ERROR_SAMPLE_RATE) ||
                1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: "#4B5563",
    },
});
